import { render } from "./spinner.vue?vue&type=template&id=1262a5bd&ts=true"
import script from "./spinner.vue?vue&type=script&lang=ts"
export * from "./spinner.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__